export default __webpack_public_path__ + "trash-2-red.svg";